// Measurements the sidebar and the top bar must share.
import { alpha, decomposeColor } from '@mui/material/styles';

// The sidebar's logo header and the top bar are the same height, so the
// hairline under each meets the other's and reads as one line across the
// screen. Before 2026-10-01 they were 86px and 64px, and the two lines sat
// 22px apart. Change this and both move together.
export const TOP_BAR_HEIGHT = 64;

/**
 * The colour at `factor` of its own opacity. MUI's alpha() SETS a colour's
 * opacity, it does not scale it: the light theme's divider is already at 0.4,
 * so alpha(divider, 0.4) handed back the same colour, and a line meant to be
 * lighter was not (caught 2026-10-01).
 */
export function fainter(color, factor) {
  const { values } = decomposeColor(color);
  const opacity = values[3] ?? 1;
  // Rounded, so 0.4 × 0.4 is 0.16 in the CSS, not 0.16000000000000003.
  return alpha(color, Math.round(opacity * factor * 1000) / 1000);
}

// Every line that frames the app — under the top bar and the logo, down the
// sidebar's edge, above its help row — is this one hairline: 40% of the
// theme's divider, the strength the logo's old line had (a Divider at
// opacity 0.4). At the full divider the line across the top read too dark;
// the four lines were three strengths before (2026-10-01).
export const frameLine = (theme) => `1px solid ${fainter(theme.palette.divider, 0.4)}`;
